var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M955 5106 c-104 -26 -129 -47 -511 -430 -401 -400 -412 -414 -435 -540 -15 -81 -1 -172 38 -250 20 -40 165 -191 661 -688 l636 -638 -636 -638 c-496 -497 -641 -648 -661 -688 -58 -115 -58 -253 0 -368 36 -74 745 -783 819 -819 115 -58 253 -58 368 0 40 20 191 165 689 661 l637 636 638 -636 c497 -496 648 -641 688 -661 115 -58 253 -58 368 0 74 36 783 745 819 819 58 115 58 253 0 368 -20 40 -165 191 -661 689 l-636 637 636 638 c496 497 641 648 661 688 58 115 58 253 0 368 -36 74 -745 783 -819 819 -115 58 -253 58 -368 0 -40 -20 -191 -165 -688 -661 l-638 -636 -637 636 c-674 672 -674 672 -791 697 -66 14 -112 13 -177 -3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.74d9375c8866225c36e03287c34d77cd.svg";
export { ForwardRef as ReactComponent };